import { useState } from "react";
import { UserPlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { EventPositionDTO } from "@/pages/admin/events/types";
import { AssignDialogContent } from "./assign-dialog/AssignDialogContent";

interface AssignEmployeeDialogProps {
  eventId: string;
  eventPositions: EventPositionDTO[];
  onEmployeeAssigned: () => void;
}

export function AssignEmployeeDialog({
  eventId,
  eventPositions,
  onEmployeeAssigned,
}: AssignEmployeeDialogProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" className="gap-2">
          <UserPlus className="h-4 w-4" />
          Assign Employee
        </Button>
      </DialogTrigger>
      {dialogOpen && (
        <AssignDialogContent
          eventId={eventId}
          eventPositions={eventPositions}
          onEmployeeAssigned={onEmployeeAssigned}
          onClose={() => setDialogOpen(false)}
        />
      )}
    </Dialog>
  );
}
